import React, { Component } from 'react';
import { safeOnClick } from '@/util/helpers/event-helpers';
import style from '../../css/module/checkbox.css';

class Checkbox extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { selected, handleChange, className } = this.props;

    const customClass = className || '';

    const onClick = !handleChange ? null : safeOnClick((e) => handleChange(e));

    return (
      <div className={`${style.checkboxContainer} ${customClass}`}>
        <span
          className={`${style.checkbox} ${
            selected ? style.checkboxChecked : ''
          }`}
          onClick={onClick}
        />
      </div>
    );
  }
}

export default Checkbox;
